define(
	'C3.ShoppingExtensions.PDP.MakeAnOffer.Countries.View',
	[
		'SCView', 
		'countriesDropdown.tpl',
		'Profile.Model',
		//'SC.Configuration',
		'Utils',
		//'Backbone.View'
		],
	function(
		SCViewComponent, 
		countriesDropdown_tpl,
		ProfileModel,
		//Configuration,
		Utils,
		//BackboneView
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function MakeAnOfferCountriesView(options) {
			SCView.call(this);
			this.options = options || {};
			this.template = countriesDropdown_tpl;		
		}

		// Inherit parent instance methods.
		MakeAnOfferCountriesView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		MakeAnOfferCountriesView.prototype.constructor = MakeAnOfferCountriesView;

		MakeAnOfferCountriesView.prototype.getContext = function() {
			var countries = this.options.countries
			,   selectedCountryName = ''

			var self = this;

			//console.log(self.options.selectedCountry)

	        var profile = ProfileModel.getInstance()
			,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

			_.each(countries,function(country){
            	if(country.code == self.options.selectedCountry){
            		selectedCountryName = country.name
            		//country.isActive = true;
            	}
            });
			return {
				countries: _.values(countries),
	        	isLoggedIn : is_logged_in,
	        	selectedCountryName : selectedCountryName,
	        	hasDefaultCountry : selectedCountryName ? true : false
			}
		}

		// Return the AMD constructor.
		return MakeAnOfferCountriesView;
	}
);
